import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { api } from '@/services/api'

const MOCK_AUTH = import.meta.env.VITE_MOCK_AUTH === 'true'
const isLocalDev =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()
  const { isAuthenticated, setUser, clearUser } = useAuthStore()
  const [checking, setChecking] = useState(!isAuthenticated && !isLocalDev && !MOCK_AUTH)

  useEffect(() => {
    if (isLocalDev || MOCK_AUTH || isAuthenticated) {
      setChecking(false)
      return
    }

    api.get('/auth/me/')
      .then(res => {
        setUser(res.data)
        setChecking(false)
      })
      .catch(() => {
        clearUser()
        const from = window.location.pathname + window.location.search
        navigate(`/login?from=${encodeURIComponent(from)}`, { replace: true })
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (checking) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#f5f7fa',
      }}>
        <div style={{ textAlign: 'center', color: '#6b7280' }}>
          <div style={{
            width: 32, height: 32,
            border: '3px solid #e5e7eb', borderTopColor: '#1E6978',
            borderRadius: '50%', animation: 'spin 0.8s linear infinite',
            margin: '0 auto 12px',
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p style={{ margin: 0, fontSize: 14 }}>Verifying your session...</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
